// InputParameters.js
import React from 'react';
import Draggable from 'react-draggable';

function InputParameters({ inputParams, inputValues, onInputChange, onExecuteReport, onClose, ReportID, ID }) {
    const sortedInputParams = [...inputParams].sort((a, b) => {
        const sortA = Number(a.Sort || 0);
        const sortB = Number(b.Sort || 0);

        return sortA - sortB;
    });

    return (
        <div className="modal fade show d-block" style={{ marginTop: "30px" }} tabIndex="-1" aria-labelledby="inputModalLabel" aria-hidden="true">
            <div className="modal-dialog">
                <Draggable handle=".modal-header">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="inputModalLabel">Input Parameters</h5>
                            <button type="button" className="close" aria-label="Close" onClick={onClose}>
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            {sortedInputParams.length > 0 ? (
                                sortedInputParams.map((param) => {
                                    debugger;
                                    if (param.Name === "ClientID" || param.Name === "UserID" || (param.Name === "ID" && ID.length > 0)) return null;
                                    return (
                                        <div key={param.ID} className="row mb-3" style={{ marginLeft: 2, marginTop: 10 }}>
                                            <label className='col-sm-3 col-form-label'>{param.DisplayName}</label>
                                            {param.options && param.options.length > 0 ? (
                                                <div className="col-sm-5">
                                                    <select
                                                        className="form-control"
                                                        value={inputValues[param.Name] || ''}
                                                        onChange={(e) => onInputChange(param.Name, e.target.value)}
                                                    >
                                                        <option value="">Select</option>
                                                        {param.options.map((option) => (
                                                            <option key={option.value} value={option.value}>
                                                                {option.label}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                            ) : (
                                                <div className="col-sm-5">

                                                    <input
                                                        className="form-control"
                                                        type={param.Type === 'date' ? 'date' : 'text'}
                                                        value={inputValues[param.Name] || ''}
                                                        onChange={(e) => onInputChange(param.Name, e.target.value)}
                                                    />
                                                </div>
                                            )}
                                        </div>
                                    );
                                })
                            ) : (
                                <p>No input parameters required</p>
                            )}
                        </div>
                        <div className="modal-footer">
                            <button
                                className="btn btn-primary"
                                onClick={() => onExecuteReport(ReportID)} // <-- always pass object
                            >
                                Execute Report
                            </button>
                            <button className="btn btn-danger" onClick={onClose}>
                                <i className="icofont-close" aria-hidden="true"> Close</i>
                            </button>
                        </div>
                    </div>
                </Draggable>
            </div>
        </div>
    );
}

export default InputParameters;
